import { DsColors } from '@levelaccess/design-system';

export const SeverityRankColourMap: Map<number, DsColors> = new Map([
  [5, DsColors.SeverityRank5],
  [4, DsColors.SeverityRank4],
  [3, DsColors.SeverityRank3],
  [2, DsColors.SeverityRank2],
  [1, DsColors.SeverityRank1],
]);
